

import React, { useEffect, useMemo, useState, useCallback } from "react";
import styled from "styled-components";
import { GoogleMap, useLoadScript, DirectionsRenderer } from "@react-google-maps/api";
import { useDispatch } from "react-redux";
import { setKmDataForKmHesaplama } from "../../features/kmCalc/kmCalcSlice";
import { useSelector } from "react-redux";

const Container = styled.div`
  width: calc(100% - 460px);
  height: 100vh;

  .map {
    width: 100%;
    height: 100%;
  }

  
  @media (max-width: 1450px) {
      width: calc(100% - 350px);
  }

  @media (max-width: 1100px) {
    border: none;
    width: 100%;
}
`;

const libraries = ["places"];

const KmHesaplamaMapSide = () => {

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY, // Replace with your Google Maps API key
    libraries,
  });

  const [map, setMap] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);

  const {route} = useSelector(state => state.kmCalc)

  // const route = useMemo(
  //   () => [
  //     { lat: 39.4809479225399, lng: 28.369711427143514 },
  //     { lat: 39.58323808204341, lng: 31.21541403140374 },
  //     { lat: 39.85507820778479, lng: 36.612440187515084 },
  //   ],
  //   []
  // );

  const center = useMemo(() => ({ lat: 38.75, lng: 33.75 }), []);
  const dispatch = useDispatch();

  const onLoad = useCallback((mapInstance) => {
    setMap(mapInstance);
  }, []);

  const rotaOptions = {
    polylineOptions: {
      strokeColor: "#BB2649",
      strokeOpacity: 1.0,
      strokeWeight: 5,
    },
  };

  useEffect(() => {
    if (isLoaded && map) {
      calculateRoute(route);
    }
  }, [isLoaded, map, route]);

  useEffect(() => {

    const filtered = route.filter(item => {
      return item.lat && item.lng
    })
    if(filtered.length < 2){
      setDirectionsResponse(null)
      dispatch(setKmDataForKmHesaplama(null))
    }

  },[route])


  const calculateRoute = async (route) => {
    try {
      const origin = route[0];
      const destination = route[route.length - 1];
      const wayPoints = route.slice(1, route.length - 1).map((waypoint) => ({
        location: {lat: waypoint.lat, lng: waypoint.lng},
      }));

      // eslint-disable-next-line no-undef
      const directionsService = new google.maps.DirectionsService();
      const results = await directionsService.route({
        origin: {lat: origin.lat, lng: origin.lng},
        destination: {lat: destination.lat, lng: destination.lng},
      // eslint-disable-next-line no-undef
        travelMode: google.maps.TravelMode.DRIVING,
        waypoints: wayPoints.length > 0 ? wayPoints : null,
      });
      const kmData = results.routes[0].legs.reduce((accumulator, item) =>  {
        return accumulator + parseFloat(item.distance.text.replace(".", ""))
    },0)

    dispatch(setKmDataForKmHesaplama(kmData))

      setDirectionsResponse(results);
    } catch (error) {
    }
  };

  if (loadError) return <div>Bir hata meydana geldi, lütfen daha sonra tekrar deneyin.</div>
  if (!isLoaded) return <div>Loading...</div>

  return (
    <Container>
      <GoogleMap
        zoom={7}
        center={center}
        mapContainerClassName="map"
        onLoad={onLoad}
        options={{
          zoomControl: true,
          zoomControlOptions: {
      // eslint-disable-next-line no-undef
            position: google.maps.ControlPosition.RIGHT_CENTER,
          },
        }}
      >
        {directionsResponse && (
          <DirectionsRenderer directions={directionsResponse} options={rotaOptions} />
        )}
      </GoogleMap>
    </Container>
  );
};

export default KmHesaplamaMapSide;